import { render } from "./ChatMessageList.vue?vue&type=template&id=32c91b28&scoped=true&ts=true"
import script from "./ChatMessageList.vue?vue&type=script&lang=ts"
export * from "./ChatMessageList.vue?vue&type=script&lang=ts"

import "./ChatMessageList.vue?vue&type=style&index=0&id=32c91b28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c91b28"]])

export default __exports__